import { render, staticRenderFns } from "./paymentOrder.vue?vue&type=template&id=47abd992&scoped=true&"
import script from "./paymentOrder.vue?vue&type=script&lang=js&"
export * from "./paymentOrder.vue?vue&type=script&lang=js&"
import style0 from "./paymentOrder.vue?vue&type=style&index=0&id=47abd992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abd992",
  null
  
)

export default component.exports